export const EXEC_REPORT_RESPONSE_TIMEOUT_MS = import.meta.env.VITE_IS_TEST_ENVIRONMENT === 'true' ? 100 : 5_000;
